// Single source of truth for the hosts that serve the *production* webapp.
// Anything else (staging, dev, localhost, Firebase preview channels) is treated
// as non-production — this drives __DEV__, the live-vs-test Stripe key, the prod
// GA property, and production timing constants. Add new production domains here.
export const PRIMARY_PRODUCTION_HOST = 'my.bodyfast.app'
export const SECONDARY_PRODUCTION_HOST = 'my2.bodyfast.app'

export const PRODUCTION_HOSTS = [PRIMARY_PRODUCTION_HOST, SECONDARY_PRODUCTION_HOST]

export const isProductionHost = (hostname: string = location.hostname): boolean =>
  PRODUCTION_HOSTS.includes(hostname)

export const STAGING_HOST = 'staging.bodyfast.de'

const STAGING_FIREBASE_HOST = /^bodyfast-staging(--[a-z0-9-]+)?\.web\.app$/

export const isStagingHost = (hostname: string = location.hostname): boolean =>
  hostname === STAGING_HOST || STAGING_FIREBASE_HOST.test(hostname)
